import React from "react"
import { GameSvg, NotificationSvg, Person1Svg, SettingSvg } from "../../assets/svg"
import { useTranslation } from "next-i18next"
import { twMerge } from "tailwind-merge"
import RetainQueryLink from "./RetainQueryLink"

export const LeftMenu = (props) => {
    const { t: tCommon } = useTranslation("common")
    const { pathname } = props.router

    return (
        <div className={"h-full w-[235px] border-r border-[#DFDDDE]"}>
            <ul className="bg-white text-14 font-medium  child:flex child:items-center child-hover:border-l-[3px] child-hover:border-accent-1 child-hover:bg-[#F5F5F5] child-hover:font-bold child-hover:text-accent-1 lg:sticky lg:top-[75px]">
                <li
                    className={twMerge(
                        "group h-[48px] cursor-pointer",
                        pathname.indexOf("my-games") >= 0 && "border-l-[3px] border-accent-1 bg-[#F5F5F5]"
                    )}
                >
                    <RetainQueryLink href={"/my-games"}>
                        <a className={"flex items-center"}>
                            <div className={"b-flex-center mr-[14px] ml-[18px] h-[20px] w-[20px]"}>
                                <GameSvg
                                    width={19}
                                    height={13}
                                    className="fill-[#546F7A] group-hover:fill-accent-1 group-hover:text-accent-1"
                                />
                            </div>
                            {tCommon("menu.myGames")}
                        </a>
                    </RetainQueryLink>
                </li>
                <li
                    className={twMerge(
                        "group h-[48px] cursor-pointer",
                        pathname.indexOf("my-account") >= 0 && "border-l-[3px] border-accent-1 bg-[#F5F5F5]"
                    )}
                >
                    <RetainQueryLink href={"/my-account"}>
                        <a className={"flex items-center"}>
                            <div className={"mr-[14px] ml-[18px]"}>
                                <Person1Svg
                                    width={17}
                                    height={19}
                                    className="fill-[#546F7A] group-hover:fill-accent-1 group-hover:text-accent-1"
                                />
                            </div>
                            {tCommon("menu.personalInfo")}
                        </a>
                    </RetainQueryLink>
                </li>
                <li
                    className={twMerge(
                        "group h-[48px] cursor-pointer",
                        pathname.indexOf("notifications") >= 0 && "border-l-[3px] border-accent-1 bg-[#F5F5F5]"
                    )}
                >
                    <RetainQueryLink href={"/notifications"}>
                        <a className={"flex items-center"}>
                            <div className={"b-flex-center mr-[14px] ml-[18px] h-[20px] w-[20px]"}>
                                <NotificationSvg
                                    width={16}
                                    height={18}
                                    className="fill-[#546F7A] group-hover:fill-accent-1 group-hover:text-accent-1"
                                />
                            </div>
                            {tCommon("menu.notifications")}
                        </a>
                    </RetainQueryLink>
                </li>
                <li
                    className={twMerge(
                        "group h-[48px] cursor-pointer",
                        pathname.indexOf("preferences") >= 0 && "border-l-[3px] border-accent-1 bg-[#F5F5F5]"
                    )}
                >
                    <RetainQueryLink href={"/preferences"}>
                        <a className={"flex items-center"}>
                            <div className={"b-flex-center mr-[14px] ml-[18px] h-[20px] w-[20px]"}>
                                <SettingSvg
                                    width={17}
                                    height={17}
                                    className="fill-[#546F7A] group-hover:fill-accent-1 group-hover:text-accent-1"
                                />
                            </div>
                            {tCommon("menu.preferences")}
                        </a>
                    </RetainQueryLink>
                </li>
            </ul>
        </div>
    )
}
